import {
  getPhotographerUserId,
  applyCoverFromMap,
  fetchPortfolioCoverMap,
} from '../services/portfolioCoverService';

/** Normalize raw photographer_profiles row → card shape for NearbyPhotographers section. */
export function buildNearbyPhotographerCard(photographer, coverMap = new Map()) {
  const photographerUserId = getPhotographerUserId(photographer);
  const displayName =
    photographer.user?.fullName ||
    photographer.user?.full_name ||
    photographer.name ||
    'مصور محترف';

  const base = {
    ...photographer,
    id: photographerUserId,
    userId: photographerUserId,
    user_id: photographerUserId,
    portfolioImage: null,
    portfolioImageAlt: 'صورة من المعرض',
    name: displayName,
    city: photographer.city || 'الرياض',
    rating: photographer.rating || 0,
    reviewCount: photographer.totalReviews || photographer.total_reviews || 0,
    isVerified: photographer.isVerified || false,
    specialties: photographer.specializations || photographer.specialties || [],
    avatar: photographer.user?.avatarUrl || photographer.user?.avatar_url || null,
    experienceLevel: photographer.experienceLevel || photographer.experience_level || null,
    distanceKm: photographer.distanceKm ?? null,
    distanceLabel: photographer.distanceLabel || null,
    shootingMethods: Array.isArray(
      photographer.shootingMethods ?? photographer.shooting_methods,
    )
      ? photographer.shootingMethods || photographer.shooting_methods
      : [],
  };

  return coverMap.size > 0 ? applyCoverFromMap(base, coverMap) : base;
}

export function buildNearbyPhotographerCards(photographers, coverMap = new Map()) {
  return photographers.map((p) => buildNearbyPhotographerCard(p, coverMap));
}

/** Progressive: merge cover images into already-rendered cards. */
export async function mergeCoversIntoNearbyCards(cards, coverIds) {
  const coverMap = await fetchPortfolioCoverMap(coverIds);
  return cards.map((card) => applyCoverFromMap(card, coverMap));
}
